'use strict';

var React = require('react');

var ServerContextContext = require('./ServerContextContext');

module.exports = function useServerContext() {
  return React.useContext(ServerContextContext);
};
